import { Breadcrumbs as MantineBreadcrumbs, Anchor, Text } from "@mantine/core";
import { Link } from "react-router-dom";

interface BreadcrumbsItem {
    link?: string;
    label: string;
    active?: boolean;
}

interface BreadcrumbsProps {
    items: BreadcrumbsItem[];
}

export const Breadcrumbs = ({ items }: BreadcrumbsProps) => (
    <div itemScope itemType="https://schema.org/BreadcrumbList">
        <MantineBreadcrumbs mb="md" mt="xs" separator="/">
            <span itemProp="itemListElement" itemScope itemType="https://schema.org/ListItem">
                <Anchor component={Link} itemProp="item" size="sm" to="/" underline="hover">
                    <span itemProp="name">Hem</span>
                </Anchor>
                <meta itemProp="position" content="1" />
            </span>
            {items.map((item: BreadcrumbsItem, index: number) => {
                const content = item.link ? (
                    <Anchor component={Link} itemProp="item" size="sm" to={item.link} underline="hover">
                        <span itemProp="name">{item.label}</span>
                    </Anchor>
                ) : (
                    <Text c={item.active ? "dimmed" : undefined} itemProp="name" size="sm">
                        {item.label}
                    </Text>
                );

                return (
                    <span
                        itemProp="itemListElement"
                        itemScope
                        itemType="https://schema.org/ListItem"
                        key={`bc-index-${index}`}>
                        {content}
                        <meta itemProp="position" content={(index + 2).toString()} />
                    </span>
                );
            })}
        </MantineBreadcrumbs>
    </div>
);
